var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mfe-section"},[_c('MyTablesList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }